import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { logoutRequest } from '../actions/AuthActions';

const Logout = ({ logout }) => {
  const url = logout();

  return url && <Redirect to={url} />;
};

const mapDispatchToProps = {
  logout: logoutRequest,
};

export default connect(null, mapDispatchToProps)(Logout);
